import { render, staticRenderFns } from "./OrderList.vue?vue&type=template&id=3425fcce&scoped=true&"
import script from "./OrderList.vue?vue&type=script&lang=js&"
export * from "./OrderList.vue?vue&type=script&lang=js&"
import style0 from "../../less/order.less?vue&type=style&index=0&id=3425fcce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3425fcce",
  null
  
)

export default component.exports